module.exports = __webpack_public_path__ + "img/word.0cacad20.svg";